import { useState, useRef, useEffect } from "react";
import SideBar from "../../components/bars/SideBar";
import styles from "../../style/Pages/ChatPage.module.css";
import ChatLayout from "../../layouts/ChatLayout";
import ChatHeader from "../../components/chat/ChatHeader";
import ChatInput from "../../components/chat/ChatInput/ChatInput";
import {
  getSelectedActivity,
  getUserDetails,
  storeSelectedActivity,
} from "../../utils/auth";
import useChatActivity from "../../hooks/useChatActivity";
import NoConvFound from "../../components/ui/NoDataFound/NoConvFound";
import ActivityPannel from "../../components/bars/ActivityPannel";
import ChatViewActivity from "../../components/chat/ChatView/ChatViewActivity";
import {
  useActivityPnl,
  useConversationActivity,
} from "../../hooks/useActivity";
import websocketservice from "../../services/websocket";
import ViewChannelPopUp from "./PopUp/ViewChannelPopUp";
import ViewGroupPopUp from "./PopUp/ViewGroupPopUp";
import PersonQuickView from "./PopUp/PersonQuickView";
import { fetchSelectedPeople } from "../../services/commonServices";

const Activity = () => {
  const chatViewRef = useRef(null);
  const [height, setHeight] = useState(40);
  // const [inputHeight, setInputHeight] = useState(80); // Initial height of the input area
  // const [maxHeight, setMaxHeight] = useState(400); // Initial height of the growing div
  const [refreshCount, setRefreshCount] = useState(0);
  const [refreshChat, setRefreshChat] = useState(0);
  const [skipLoader, setSkipLoader] = useState(false);

  const [refreshConv, setRefreshConv] = useState(0);
  const selectedUser = getSelectedActivity();
  const selectedUserRef = useRef(selectedUser);

  const userDetails = getUserDetails() || {};
  const [focusedMessageId, setfocusedMessageId] = useState("");
  const [showChannelPopup, setShowChannelPopup] = useState(false);
  const [showGroupPopup, setShowGroupPopup] = useState(false);
  const [showPersonPopUp, setShowPersonPopUp] = useState(false);
  const { activity, loading } = useActivityPnl(skipLoader, refreshCount);
  const userName = selectedUser?.name || "";
  const BASE_URL = process.env.REACT_APP_API_URL;
  const channelId = selectedUser?.id; // Assuming this is available
  const groupId = selectedUser?.group_id;
  const userId = selectedUser?.user_id;
  const userImage = selectedUser?.emp_pic;
  const onlineStatus = selectedUser?.online_status;
  const {
    text,
    setText,
    uploadedFiles,
    inputRef,
    handleFileChange,
    handleRemoveFile,
    handleSend,
    handleChange,
    clearSendingMessage,
    clearRecivingMessage,
    reactions,
    typing,
    insertMentionUser,
    sendingmessage: chatSendingMessage, // Renamed
    recivingMessage: recivedMessageSocket,
    pendingMessages,
    setPendingMessages,
    setUploadedFiles,
  } = useChatActivity(refreshChat);

  const {
    loadingConv,
    sendingmessage: convSendingMessage,
    recivingMessage: recivingMessageApi,
  } = useConversationActivity(refreshConv);

  const handleWorkspaceUpdate = () => {
    setRefreshCount((prev) => prev + 1); // Trigger refresh
    setRefreshConv((prev) => prev + 1);
    setPendingMessages(false);
    setText([]);
    setUploadedFiles([]);
  };
  const handleUpdated = () => {
    setRefreshCount((prev) => prev + 1); // Trigger refresh
  };

  const renderChatInput = () => {
    // Deactivated in channel
    if (selectedUser?.status === "1") {
      return (
        <div className={styles.DisabledInput}>
          You are viewing the archives of a deactivated account
        </div>
      );
    }

    // Channel access restrictions
    if (selectedUser?.type === "channel") {
      if (selectedUser.allow_access === "only_manager") {
        const isManager = selectedUser.channel_manager?.includes(
          userDetails.id
        );
        if (!isManager) {
          return (
            <div className={styles.DisabledInput}>
              Only managers can send messages in this channel
            </div>
          );
        }
      }
    }

    // Default → show the real input
    return (
      <ChatInput
        text={text}
        setText={setText}
        uploadedFiles={uploadedFiles}
        handleFileChange={handleFileChange}
        handleRemoveFile={handleRemoveFile}
        handleSend={handleSend}
        handleChange={handleChange}
        inputRef={inputRef}
        insertMentionUser={insertMentionUser}
        onHeightChange={setHeight}
        setfocusedMessageId={setfocusedMessageId}
      />
    );
  };

  let query = "";
  if (selectedUser) {
    if (selectedUser.is_group_chat === "0") {
      query = `register_id=${selectedUser.user_id}`;
    } else if (selectedUser.is_group_chat === "1") {
      query = `group_id=${selectedUser.group_id}`;
    } else if (selectedUser.is_group_chat === "channel") {
      query = `channel_id=${selectedUser.id}`;
    }
  }
  useEffect(() => {
    selectedUserRef.current = selectedUser;
  }, [selectedUser]);

  useEffect(() => {
    const updateSelectedUserFromApi = async () => {
      if (!selectedUserRef.current) return;

      try {
        let updatedData = null;
        const res = await fetchSelectedPeople(`?${query}`);

        if (selectedUserRef.current.is_group_chat === "channel") {
          // Fetch channel details

          updatedData = {
            ...selectedUserRef.current,
            channel_name: res?.channel_details[0]?.channel_name,
            allow_access:
              res?.identify_active_deactive.channel_details[0]?.allow_access,
            channel_manager:
              res?.identify_active_deactive.channel_details[0]?.channel_manager, // assuming API returns icon
          };
        } else if (selectedUserRef.current.is_group_chat === "1") {
          // Fetch group details
          updatedData = {
            ...selectedUserRef.current,
            name: res?.identify_active_deactive.group_details[0]?.group_name,
            emp_pic: res?.identify_active_deactive.group_details[0]?.group_icon,
            group_status:
              res?.identify_active_deactive?.group_details[0]?.group_status,
          };
        } else if (selectedUserRef.current.is_group_chat === "0") {
          // Fetch user details
          updatedData = {
            ...selectedUserRef.current,
            name: res?.identify_active_deactive?.employee_details[0]?.name,
            emp_pic:
              res?.identify_active_deactive?.employee_details[0]?.emp_pic,
            active_status:
              res?.identify_active_deactive?.employee_details[0]?.active_status,
          };
        }

        if (
          updatedData &&
          JSON.stringify(updatedData) !==
            JSON.stringify(selectedUserRef.current)
        ) {
          storeSelectedActivity(updatedData); // update localStorage
        }
      } catch (error) {}
    };

    updateSelectedUserFromApi();
  }, [query]);

  const allMessages = [
    ...(chatSendingMessage || []).map((msg) => ({
      isReceived: false,
      userName: userDetails.name, // current user sending
      text: msg.message,
      time: msg.time,
      date: msg.date,
      file: msg.file_url,
      id: msg.message_id,
      reactions:
        msg.reactions?.map((r) => ({
          ...r,
          react_emoji:
            typeof r.react_emoji === "string"
              ? JSON.parse(r.react_emoji)
              : r.react_emoji,
        })) || [],
      avatar: `${BASE_URL}${msg.emp_pic}`,
    })),
    ...(convSendingMessage || []).map((msg) => ({
      isReceived: false,
      userName: userDetails.name, // current user sending
      text: msg.message,
      time: msg.time,
      date: msg.date,
      file: msg.file_url,
      id: msg.message_id,
      reactions:
        msg.reactions?.map((r) => ({
          ...r,
          react_emoji:
            typeof r.react_emoji === "string"
              ? JSON.parse(r.react_emoji)
              : r.react_emoji,
        })) || [],

      avatar: `${BASE_URL}${msg.emp_pic}`,
    })),
    ...(recivingMessageApi || []).map((msg) => ({
      isReceived: true,
      userName: msg.name,
      text: msg.message,
      time: msg.time,
      date: msg.date,
      id: msg.message_id,
      reactions:
        msg.reactions?.map((r) => ({
          ...r,
          react_emoji:
            typeof r.react_emoji === "string"
              ? JSON.parse(r.react_emoji)
              : r.react_emoji,
        })) || [],
      file: msg.file_url,
      avatar: `${BASE_URL}${msg.emp_pic}`,
    })),
    ...(recivedMessageSocket || []).map((msg) => ({
      isReceived: true,
      userName: msg.name,
      text: msg.message,
      time: msg.time,
      date: msg.date,
      id: msg.message_id,
      reactions: msg.reactions,

      file: msg.file_url,
      avatar: `${BASE_URL}/${msg?.avatar}`,
    })),
  ].sort((a, b) => {
    const parseDateTime = (message) => {
      const [timePart, period] = message.time.split(" ");
      const [hours, minutes, seconds] = timePart.split(":").map(Number); // Include seconds
      let adjustedHours = hours;

      if (period === "PM" && adjustedHours < 12) adjustedHours += 12;
      if (period === "AM" && adjustedHours === 12) adjustedHours = 0;

      const date = new Date(message.date);
      date.setHours(adjustedHours, minutes, seconds || 0, 0); // Set seconds here
      return date.getTime();
    };

    return parseDateTime(a) - parseDateTime(b);
  });

  useEffect(() => {
    const handleFocus = () => {
      setSkipLoader(true);
      setRefreshCount((prev) => prev + 1);
      // setRefreshConv((prev) => prev + 1);
      // setRefreshChat((prev) => prev + 1); // This reloads the active chat view
      clearSendingMessage();
      clearRecivingMessage();
    };
    clearSendingMessage();
    clearRecivingMessage();

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [clearSendingMessage, clearRecivingMessage]);

  const onSelectConversation = (data) => {
    websocketservice.disconnect();

    setfocusedMessageId(data.data.message_id);
    setRefreshCount((prev) => prev + 1);
    setRefreshConv((prev) => prev + 1);
    setRefreshChat((prev) => prev + 1);
    setPendingMessages(false); // Add this line
    clearSendingMessage();
    clearRecivingMessage();
    storeSelectedActivity(data.data);
    setText([]);
    setUploadedFiles([]);
  };

  const handleHeaderClick = () => {
    if (selectedUser?.is_group_chat === "channel") {
      setShowChannelPopup(true);
    } else if (selectedUser?.is_group_chat === "1") {
      setShowGroupPopup(true);
    } else {
      setShowPersonPopUp(true);
    }
  };
  // Cleanup URLs on unmount
  return (
    <>
      <ChatLayout
        sidebar={<SideBar onWorkspaceUpdate={handleWorkspaceUpdate} />}
        chatPannel={
          <ActivityPannel
            activity={activity}
            loading={loading}
            onSelectedConversation={onSelectConversation}
          />
        }
        mainContent={
          <div className={styles.ChatPageMainContent}>
            <div className={styles.ChatPageMainContentSub}>
              {selectedUser ? (
                <>
                  <ChatHeader
                    userName={userName}
                    userImage={userImage}
                    status={onlineStatus}
                    typing={typing}
                    onHeaderClick={handleHeaderClick}
                    type={selectedUser?.is_group_chat}
                    pageFrom={"activity"}
                  />
                  <div className={styles.ChatPageMessageInput}>
                    <ChatViewActivity
                      messages={allMessages}
                      chatViewRef={chatViewRef}
                      isLoading={loadingConv}
                      height={height} // Pass the height state
                      newReaction={reactions}
                      focusedMessageId={focusedMessageId}
                      pendingMessages={pendingMessages}
                      chat_unique={selectedUser?.chat_unique}
                      typing={typing}
                    />
                    {/* {renderChatInput()} */}
                  </div>
                </>
              ) : (
                <>
                  <NoConvFound />
                </>
              )}
            </div>
          </div>
        }
      />
      {showChannelPopup && (
        <ViewChannelPopUp
          onClose={() => setShowChannelPopup(false)}
          channelId={channelId}
          updated={handleUpdated}
        />
      )}{" "}
      {showGroupPopup && (
        <ViewGroupPopUp
          onClose={() => setShowGroupPopup(false)}
          groupId={groupId}
          updated={handleUpdated}
        />
      )}
      {showPersonPopUp && (
        <PersonQuickView
          userId={userId}
          onClose={() => setShowPersonPopUp(false)}
        />
      )}
    </>
  );
};

export default Activity;
